import React from "react";
import ProjectSlider from "../ProjectsSlider";
import Gradient from "../Gradient";

const ProjectsSection = ({ data, anchorId }) => {
  if (!data) return null;

  const { title, subTitle, projectSlide } = data;

  return (
    <section className="section projects-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="projects-header">
          <span className="subTitle">{subTitle}</span>
          <h2>{title}</h2>
        </div>
        <div className="projects-main">
          <ProjectSlider slides={projectSlide} />
        </div>
      </div>
      <Gradient
        imageName="gradient8"
        className="gradientPulse"
        top="-300px"
        left="-300px"
        right="-300px"
        bottom="-200px"
      />
    </section>
  );
};

export default ProjectsSection;
